module.exports = __webpack_public_path__ + "img/Butterfinger.0a1e3322.webp";